import { useNavigate } from 'react-router-dom';

const Breadcrumb = ({ items }) => {
  const navigate = useNavigate();
  return (
    <nav className="breadcrumb">
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <span key={i} className="breadcrumb__item">
            {!isLast && item.to ? (
              <button className="breadcrumb__link" onClick={() => navigate(item.to)}>
                {item.label}
              </button>
            ) : (
              <span className="breadcrumb__current">{item.label}</span>
            )}
            {!isLast && <span className="breadcrumb__sep">›</span>}
          </span>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
